"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validate = require("validate.js");
const axios_1 = require("axios");
exports.default = (value, options) => {
    if (value === "" || value === null || value === undefined) {
        return Promise.resolve();
    }
    return new validate.Promise(function (resolve) {
        axios_1.default
            .post(options.url, { value })
            .then(res => res.data)
            .then(data => {
            if (!data.isValid) {
                return resolve(options.message);
            }
            resolve();
        });
    });
};
//# sourceMappingURL=remoteCheck.js.map